// Satranc365 Social (#1026) ships dark: pages 404 unless the flag is on.
// Usable from server and client components (NEXT_PUBLIC_ is inlined at build).
export const isSocialEventsEnabled = () =>
    process.env.NEXT_PUBLIC_SOCIAL_EVENTS_ENABLED === "true";

// Audience view (#1032) ships dark the same way.
export const isAudienceViewEnabled = () =>
    process.env.NEXT_PUBLIC_AUDIENCE_VIEW_ENABLED === "true";
